<template>
  <div ref="echart01" style="width:100%; height:210px;"></div>
</template>

<script>
export default {
  props: {
    data07:
            {
              type: Array
            }
  },
  mounted() {
    let chart01 = this.$echarts.init(this.$refs.echart01)
    var data = this.data07
    let total =0;
    for(let i =0;i<this.data07.length;i++){
       total+=this.data07[i].value
    }
    // var data = [
    //   {
    //     name: '已打卡',
    //     value: 456
    //   },
    //   {
    //     name: '补卡',
    //     value: 231
    //   },
    //   {
    //     name: '请假',
    //     value: 121
    //   },
    //   {
    //     name: '未打卡',
    //     value: 45
    //   }
    // ]

    let option = {
      //color: ['rgba(150,100, 221)', 'rgba(95, 169, 249)', 'rgba(71,233,231 )', 'rgba(253,130,45)'],
      color: ['#2e66fd', '#2cb9b0', '#ff8218', '#fec600'],
      // backgroundColor: '#0f375f',
      title: {
        text: total,
        subtext: '总计',
        textStyle: {
          color: '#000',
          fontSize: 10
        },
        subtextStyle: {
          fontSize: 10,
          color: ['#000']
        },
        x: '122',
        y: '90'
      },
      grid: {
        bottom: 150,
        left: 0,
        right: '10%'
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}<br/> {c}人  ({d}%)'
      },
      legend: {
        backgroundColor: 'rgba(242, 248, 255)',
        orient: 'vertical',
        right: 50,
        textStyle: {
          color: '#000',
          fontSize: 12
        },
        icon: 'roundRect',
        data: data
      },
      series: [
        // 主要展示层的
        {
          radius: ['40%', '80%'],
          center: ['30%', '50%'],
          type: 'pie',
          label: {
            position: 'outside',
            formatter: '{b}：{c}人'
          },
          labelLine: {
            normal: {
              show: true,
              length: 10,
              length2: 10
            },
            emphasis: {
              show: true
            }
          },
          data: data
        },
        // 边框的设置
        {
          radius: ['35%', '40%'],
          center: ['30%', '50%'],
          type: 'pie',
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          labelLine: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          animation: false,
          tooltip: {
            show: false
          },
          data: [
            {
              value: 1,
              itemStyle: {
                color: 'rgba(250,250,250,0.3)'
              }
            }
          ]
        },
        {
          name: '外边框',
          type: 'pie',
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          center: ['30%', '50%'],
          radius: ['90%', '90%'],
          label: {
            normal: {
              show: false
            }
          },
          data: [
            {
              value: 9,
              name: '',
              itemStyle: {
                normal: {
                  borderWidth: 2,
                  borderColor: '#0b5263'
                }
              }
            }
          ]
        }
      ]
    }

    chart01.setOption(option, true)
  }
}
</script>

<style></style>
